/**
 * Guard de rota baseado em papel (RBAC).
 *
 * - Não autenticado → redireciona para /login.
 * - Autenticado mas papel insuficiente → /unauthorized.
 * - OK → renderiza children.
 */
import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { useAuth } from '../lib/auth'
import type { Role } from '../types/api'

interface Props {
  allowedRoles: Role[]
}

export function PrivateRoute({ allowedRoles }: Props) {
  const { isAuthenticated, user } = useAuth()
  const location = useLocation()

  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />
  }

  if (user && !allowedRoles.includes(user.role)) {
    return <Navigate to="/unauthorized" replace />
  }

  return <Outlet />
}
